import { Divider, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { DateSeparatorProps } from 'stream-chat-react';

import { formatMessageDate } from '../utils';

export const ChannelDateSeparator: FC<DateSeparatorProps> = ({ date, unread }) => {
  const formattedDate = formatMessageDate(date);
  const { formatMessage } = useIntl();
  return (
    <Stack direction="row" alignItems="center" pb={2}>
      <Divider
        sx={{
          flex: 1,
          borderColor: unread ? 'success.main' : undefined,
        }}
      />
      <Typography color="primary.main" px={1}>
        {formattedDate}
      </Typography>
      <Stack direction="row" gap={0.5} flex={1} alignItems="center" minWidth={0}>
        <Divider
          sx={{
            flex: 1,
            minWidth: 0,
            borderColor: unread ? 'success.main' : undefined,
          }}
        />
        {unread && (
          <Typography color="success.main" sx={{ flexShrink: 0 }}>
            {formatMessage({ id: 'messages-ThreadChannelUnread' })}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
